import type { IkonAdi } from "@koclukpanel/ui";

/**
 * ÇALIŞMA ALANI MODELİ — UI/UX Dalga 2 (M1, Emre kararı D1, 06.10.2026)
 *
 * ================================================================
 * NEDEN: MENÜ KENDİNİ TEKRAR EDİYORDU
 * ================================================================
 * Ölçüldü (05.10.2026): koçta yan menüde 28 girdi vardı ve bunların 17'si
 * "Öğrenci" bölümündeydi — Program, Konu ilerlemesi, Kaynaklar, Denemeler,
 * Veli raporları, Hata defteri... Aynı ekranların HEPSİ öğrenci 360°'nın
 * sekmesi olarak zaten vardı (`ogrenci360/sekmeler.tsx`). Menü, 360°'ın
 * içindekileri bir de dışarıdan sayıyordu.
 *
 * Çözüm: yan menüdeki girdi bir EKRAN değil bir ALAN. Alanın içindeki
 * ekranlar sayfanın üstünde yatay sekme olarak duruyor; öğrenci bağlamlı
 * ekranlar menüden kalkıyor ve yalnızca 360° sekmesi (ya da bağlantı:
 * iş listesi, bildirim) olarak açılıyor.
 *
 * ================================================================
 * KORUNAN ŞEYLER — hiçbiri değişmiyor
 * ================================================================
 * - Ekran anahtarları (`program`, `loglar`…), adresler (`/program`),
 *   bildirim ve iş listesi bağlantıları, `MENU` tanımı (izinler orada).
 *   Bu dosya yalnızca "hangi ekranlar hangi alanın içinde" bilgisini ve
 *   görünürlük kuralını taşıyor.
 * - İzin süzgeci TEK kaynaktan: bir ekranın görünürlüğü `MENU`deki izninden
 *   geliyor; alan, içindeki en az bir ekran görünürse görünür. Rol ADINA
 *   dallanma yok (CLAUDE.md kural 1).
 *
 * ⚠️ Menü gizlemek güvenlik değil, kolaylık: asıl kontrol her uçta sunucuda.
 */

export interface AlanTanimi {
  /**
   * Alanın kararlı kimliği. Bir EKRAN anahtarı değil — `personel` hem alan hem
   * ekran adı; ikisi hiçbir yerde karıştırılmıyor (alan → ekran için
   * `gorunurAlanlar`ın `giris` alanı, ekran → alan için `alanOf`).
   */
  anahtar: string;
  etiket: string;
  ikon: IkonAdi;
  /** Yan menüdeki AÇILIR GRUBUN anahtarı (`MENU_GRUPLARI`); yoksa üst düzey tek girdi. */
  grup?: string;
  /**
   * Ayırıcı çizgiyle başlayan, büyük harf kalın başlıklı ALT BÖLÜM (`MENU_GRUPLARI`,
   * tür `bolum`) — UNİKOÇ'taki "ÖDÜL MERKEZİ". Başlık tıklanmaz, daralmaz.
   */
  bolum?: string;
  /** Sayfanın üstünde SEKME olarak çizilen ekranlar, bu sırayla. */
  sekmeler: readonly string[];
  /**
   * Alana ait ama sekmesi OLMAYAN ekranlar: öğrenci bağlamlı ekranlar. Menüden
   * değil, liste ya da bağlantıdan açılıyor; açıkken menüde bu alan seçili
   * görünüyor. İzni olan ama sekmeli ekranı olmayan biri alanı yine görsün diye
   * (ör. yalnızca öğrenci 360° açabilen rol) giriş ekranı olabilirler.
   */
  baglamli?: readonly string[];
  /** F-MNT-01 — tek bölüm görünse de modülün menü adı korunabilir. */
  etiketiKoru?: boolean;
}

export interface MenuGrubuTanimi {
  anahtar: string;
  etiket: string;
  ikon: IkonAdi;
  /** `acilir`: başlığa basınca açılıp kapanan grup · `bolum`: ayırıcılı sabit başlık (ÖDÜL MERKEZİ). */
  tur: "acilir" | "bolum";
}

/**
 * ================================================================
 * UNİKOÇ MENÜSÜ — sürüm 9a (Emre kararı 07.10.2026, ONERI §2–§3)
 * ================================================================
 * Personel paneli müşterinin eski paneline (UNİKOÇ) birebir getirildi. Menü
 * artık eski panelin SIRASI ve ADLARIYLA: üstte Anasayfa ve Bildirimlerim,
 * açılır "Öğrencilerim" ve "Seans ve Talepler", tek girdiler, yönetim grupları,
 * hesap girdileri, en altta "ÖDÜL MERKEZİ" bölümü. Çıkış Yap kabuğun kendisinde
 * (her zaman EN ALTTA).
 *
 * 06.10'daki alan modeli (D1) korunuyor: girdi hâlâ bir ALAN, birden çok ekranı
 * olan alan sayfanın üstünde sekme çiziyor (Deneme Sınavları, Ders İşlemleri,
 * KVKK). Değişen, öğrenci ekranlarının yeniden menüde AYRI girdi olması — eski
 * panelin kullanıcısı onları menüde arıyor; 360° sekmeleri yerinde duruyor.
 *
 * Bilerek ALINMAYANLAR: Kütüphane Salonu (Emre plandan çıkardı), Çalışma
 * İstatistikleri ve Gelişim Takip (ayrı ekran değil, Analiz ve Raporlama'nın
 * içinde). Notlarım sürüm 9a D1'de eklendi (koçun kişisel notları, `PersonalNote`).
 */
export const MENU_GRUPLARI: readonly MenuGrubuTanimi[] = [
  { anahtar: "ogrencilerim", etiket: "Öğrencilerim", ikon: "ogrenci", tur: "acilir" },
  { anahtar: "seans", etiket: "Seans ve Talepler", ikon: "seans", tur: "acilir" },
  { anahtar: "satis", etiket: "Satış", ikon: "aday", tur: "acilir" },
  { anahtar: "finans", etiket: "Finans", ikon: "finans", tur: "acilir" },
  { anahtar: "personel", etiket: "Personel", ikon: "personel", tur: "acilir" },
  { anahtar: "yonetim", etiket: "Yönetim", ikon: "yonetim", tur: "acilir" },
  { anahtar: "sistem", etiket: "Sistem", ikon: "sistem", tur: "acilir" },
  { anahtar: "odul", etiket: "Ödül Merkezi", ikon: "hediye", tur: "bolum" },
];

/**
 * Alanlar. Sıra = menüde görünme sırası; sekme sırası = ekranın günlük
 * kullanım sırası (en sık bakılan önce). Aynı grubun girdileri ARDIŞIK
 * yazılıyor; kabuk grubu ilk girdisinin yerinde çiziyor.
 */
export const ALANLAR: readonly AlanTanimi[] = [
  { anahtar: "bugun", etiket: "Anasayfa", ikon: "anasayfa", sekmeler: ["bugun"] },
  /*
    Bildirimlerim artık MENÜDE de var (UNİKOÇ'ta ikinci sırada). Sağ üstteki zil
    yerinde duruyor (F-NTF-09 "her ekranda aynı yerde"); menü ikinci bir yol.
  */
  {
    anahtar: "bildirimler",
    etiket: "Bildirimlerim",
    ikon: "bildirim",
    sekmeler: ["bildirimler"],
  },

  // --- Öğrencilerim ▾ ---
  {
    anahtar: "program",
    etiket: "Haftalık Program",
    ikon: "program",
    grup: "ogrencilerim",
    sekmeler: ["program"],
  },
  {
    anahtar: "konu-plani",
    etiket: "Müfredat Planlama",
    ikon: "mezun",
    grup: "ogrencilerim",
    sekmeler: ["konu-plani"],
  },
  {
    anahtar: "konular",
    etiket: "Konu Takibi",
    ikon: "hedef",
    grup: "ogrencilerim",
    sekmeler: ["konular"],
  },
  {
    anahtar: "canli-calisma",
    etiket: "Canlı Çalışma Takibi",
    ikon: "canli",
    grup: "ogrencilerim",
    sekmeler: ["canli-calisma"],
  },
  /*
    "Öğrenci İşleri" = öğrenci listesi + öğrencinin 360°'ı + dosyası (ONERI §2:
    "tek giriş"). 360° ve dosya öğrenci bağlamlı: listeden açılıyor.
  */
  {
    anahtar: "ogrenci-isleri",
    etiket: "Öğrenci İşleri",
    ikon: "bilgi",
    grup: "ogrencilerim",
    sekmeler: ["ogrenciler"],
    baglamli: ["ogrenci-360", "dosya"],
  },
  {
    anahtar: "ogrenci-planlari",
    etiket: "Öğrenci Planları",
    ikon: "plan",
    grup: "ogrencilerim",
    sekmeler: ["ogrenci-planlari"],
  },
  {
    anahtar: "denemeler",
    etiket: "Deneme Sınavları",
    ikon: "deneme",
    grup: "ogrencilerim",
    sekmeler: ["denemeler", "deneme-tanim"],
  },
  // Bizde olup UNİKOÇ'ta olmayan koç ekranı — "uygun gruba alt öğe" (ONERI §2).
  {
    anahtar: "hata-defteri",
    etiket: "Hata Defteri",
    ikon: "defter",
    grup: "ogrencilerim",
    sekmeler: ["hata-defteri"],
  },

  // --- Seans ve Talepler ▾ ---
  {
    anahtar: "kocluk",
    etiket: "Seans Raporlarım",
    ikon: "gorusme",
    grup: "seans",
    sekmeler: ["kocluk"],
  },
  /*
    Tanışma görüşmeleri YALNIZ burada (ONERI §3 admin için "Satış" altında da
    sayıyor): bir ekran iki menü yerinde durursa aktif vurgu ikisinden birini
    seçmek zorunda kalır ve kullanıcı "hangisi" diye bakar. Koç da admin de
    ekranı burada buluyor; Satış grubunda Adaylar kalıyor.
  */
  {
    anahtar: "gorusmeler",
    etiket: "Tanışma Seanslarım",
    ikon: "seans",
    grup: "seans",
    sekmeler: ["gorusmeler"],
  },
  {
    anahtar: "talepler",
    etiket: "Öğrenci Talepleri",
    ikon: "talep",
    grup: "seans",
    sekmeler: ["talepler"],
  },
  /*
    Takvim (koçun kendi mesaisi ve görüşme saatleri) "Personel" grubuna değil
    buraya: koçta Personel grubunun TEK girdisi olurdu ve koç kendi takvimini
    "Personel" başlığı altında aramaz. Seanslar zaten takvime bağlı.
  */
  { anahtar: "takvim", etiket: "Takvim", ikon: "takvim", grup: "seans", sekmeler: ["takvim"] },

  // --- Tek girdiler ---
  {
    anahtar: "haftalik-analiz",
    etiket: "Analiz ve Raporlama",
    ikon: "analiz",
    sekmeler: ["haftalik-analiz"],
  },
  { anahtar: "raporlar", etiket: "Veli Raporu", ikon: "rapor", sekmeler: ["raporlar"] },
  /*
    Ders İşlemleri = UNİKOÇ'taki "Dersler / Konular / Genel Kaynaklar /
    Öğrenciye Özel Kaynaklar" sekmeleri: müfredat + kaynak havuzu + öğrenci
    kaynakları.
  */
  {
    anahtar: "ders-islemleri",
    etiket: "Ders İşlemleri",
    ikon: "mufredat",
    sekmeler: ["mufredat", "kaynaklar", "ogrenci-kaynak"],
  },
  { anahtar: "operasyon", etiket: "Görevlerim", ikon: "gorevler", sekmeler: ["operasyon"] },
  // Sürüm 9a — UNİKOÇ'taki yeri: Görev'den sonra (tarama-2 §4.1). Kişinin kendi notları.
  { anahtar: "notlarim", etiket: "Notlarım", ikon: "duzenle", sekmeler: ["notlarim"] },
  { anahtar: "mesajlar", etiket: "Mesajlar", ikon: "sohbet", sekmeler: ["mesajlar"] },

  // --- Yönetim grupları (her girdi yine izinle; koçta çoğu hiç görünmez) ---
  { anahtar: "adaylar", etiket: "Adaylar", ikon: "aday", grup: "satis", sekmeler: ["adaylar"] },
  { anahtar: "finans", etiket: "Finans", ikon: "finans", grup: "finans", sekmeler: ["finans"] },
  /*
    Abonelik öğrenci bağlamlı bir ekran (öğrenci seçtiriyor) ama işi finans:
    ONERI §3 onu Finans grubuna koyuyor.
  */
  {
    anahtar: "abonelik",
    etiket: "Abonelik",
    ikon: "abonelik",
    grup: "finans",
    sekmeler: ["abonelik"],
  },
  { anahtar: "risk", etiket: "Yenileme Riski", ikon: "risk", grup: "finans", sekmeler: ["risk"] },
  {
    anahtar: "personel",
    etiket: "Personel",
    ikon: "personel",
    grup: "personel",
    sekmeler: ["personel"],
  },
  {
    anahtar: "personel-360",
    etiket: "Personel 360°",
    ikon: "hesap",
    grup: "personel",
    sekmeler: ["personel-360"],
  },
  // F-MNT-01/14 — bölümler izin ve modül durumuyla kabukta ayrı ayrı süzülür.
  {
    anahtar: "mentorum",
    etiket: "Mentörüm",
    etiketiKoru: true,
    ikon: "gorusme",
    grup: "yonetim",
    sekmeler: ["mentorum", "mentorum-risk", "mentorum-kayitlar"],
  },
  {
    anahtar: "onay",
    etiket: "Onay Bekleyenler",
    ikon: "onay",
    grup: "yonetim",
    sekmeler: ["onay"],
  },
  {
    anahtar: "roller",
    etiket: "Rol ve İzinler",
    ikon: "rol",
    grup: "yonetim",
    sekmeler: ["roller"],
  },
  {
    anahtar: "gorunum",
    etiket: "Kullanıcı Görünümü",
    ikon: "gorunum",
    grup: "yonetim",
    sekmeler: ["gorunum"],
  },
  {
    anahtar: "loglar",
    etiket: "Denetim Kaydı",
    ikon: "log",
    grup: "yonetim",
    sekmeler: ["loglar"],
  },
  {
    anahtar: "etkinlik",
    etiket: "Etkinlik Özeti",
    ikon: "etkinlik",
    grup: "yonetim",
    sekmeler: ["etkinlik"],
  },
  {
    anahtar: "mesaj-denetim",
    etiket: "Yazışma Denetimi",
    ikon: "yazismaDenetimi",
    grup: "yonetim",
    sekmeler: ["mesaj-denetim"],
  },
  /*
    SİSTEM — sağlık → güvenlik → yedek → geri yükleme → kurtarma → şablon →
    entegrasyon → teknik (mutabakat madde 4: sistemi izleyen kişi önce "ayakta
    mı" sorusunu soruyor).
  */
  {
    anahtar: "sistem",
    etiket: "Sistem Sağlığı",
    ikon: "bugun",
    grup: "sistem",
    sekmeler: ["sistem"],
  },
  {
    anahtar: "guvenlik",
    etiket: "Güvenlik",
    ikon: "guvenlik",
    grup: "sistem",
    sekmeler: ["guvenlik"],
  },
  { anahtar: "yedek", etiket: "Yedekleme", ikon: "yedek", grup: "sistem", sekmeler: ["yedek"] },
  {
    anahtar: "geri-yukleme",
    etiket: "Geri Yükleme",
    ikon: "geriYukleme",
    grup: "sistem",
    sekmeler: ["geri-yukleme"],
  },
  {
    anahtar: "kurtarma",
    etiket: "Kurtarma",
    ikon: "kurtarma",
    grup: "sistem",
    sekmeler: ["kurtarma"],
  },
  {
    anahtar: "sablonlar",
    etiket: "Bildirim Şablonları",
    ikon: "sablon",
    grup: "sistem",
    sekmeler: ["sablonlar"],
  },
  {
    anahtar: "entegrasyonlar",
    etiket: "Entegrasyonlar",
    ikon: "entegrasyon",
    grup: "sistem",
    sekmeler: ["entegrasyonlar"],
  },
  {
    anahtar: "teknik",
    etiket: "Teknik Konsol",
    ikon: "teknik",
    grup: "sistem",
    sekmeler: ["teknik"],
  },

  // --- Hesap girdileri: kişinin KENDİ hesabı, kimlik yeterli ---
  { anahtar: "hesap", etiket: "Profilim", ikon: "profil", sekmeler: ["hesap"] },
  { anahtar: "yardim", etiket: "Yardım", ikon: "yardim", sekmeler: ["yardim"] },
  /*
    KVKK burada, Yönetim grubunda DEĞİL (ONERI §3 admin için orada sayıyor):
    personel için ekranın işe yarayan kısmı "Onaylarım" ve "Başvurular" (kişi
    kendi rızasını yönetiyor) ve ikisi de `@KimlikGerekli`. Yönetim grubuna
    konsaydı koç yalnız bu girdi için "Yönetim" diye bir grup görürdü.
    "canli-bilgilendirme" (F-LIV-07) KVKK'nın ikinci sekmesi.
  */
  { anahtar: "kvkk", etiket: "KVKK", ikon: "kvkk", sekmeler: ["kvkk", "canli-bilgilendirme"] },

  // --- ÖDÜL MERKEZİ (ayırıcılı bölüm) ---
  // Dört girdi, tek yönetim ekranı: her biri ekranın ilgili sekmesini açıyor (Uygulama.tsx ODUL_ILK_BOLUM).
  {
    anahtar: "oyunlastirma",
    etiket: "Davet Ettiklerim",
    ikon: "aday",
    bolum: "odul",
    sekmeler: ["oyunlastirma"],
  },
  {
    anahtar: "odul-cark",
    etiket: "Bonus Çarkı",
    ikon: "yeni",
    bolum: "odul",
    sekmeler: ["odul-cark"],
  },
  {
    anahtar: "odul-magaza",
    etiket: "Mağaza",
    ikon: "hediye",
    bolum: "odul",
    sekmeler: ["odul-magaza"],
  },
  {
    anahtar: "odul-siparis",
    etiket: "Sipariş Geçmişim",
    ikon: "rapor",
    bolum: "odul",
    sekmeler: ["odul-siparis"],
  },
];

/**
 * İZİN ALANI OLMAYAN (kimlik yeterli) menü ekranları — AÇIK BEYAZ LİSTE.
 *
 * `izin: undefined` "herkese görünür" demek ve yazması unutulunca da aynı
 * sonucu veriyor: ölçüldü (05.10.2026), Denetim kaydı ve KVKK koçta bu yüzden
 * görünüyordu. Kural tersine çevrildi: izinsiz ekran YALNIZ burada olabilir,
 * yoksa `menu-alanlari.test.ts` kırılır. Yeni bir ekranda izin yazmayı
 * unutmak menüyü AÇIK değil, testi KIRMIZI bırakır.
 *
 *  bugun        — herkesin ana ekranı; içindeki her kaynak kendi iznini kontrol ediyor
 *  bildirimler  — kişinin KENDİ gelen kutusu; izne bağlamak, izni olmayana gönderilen
 *                 bildirimi gizlemek olurdu
 *  yardim       — herkese açık içerik, rolüne göre süzülüyor (sunucuda)
 *  hesap        — kişinin kendi hesabı/şifresi/2FA'sı
 *  kvkk         — kişinin kendi rızaları ve kendi başvuruları (`@KimlikGerekli`)
 *  notlarim     — kişinin KENDİ notları; matris §5.6 izin kodu tanımlamıyor (yalnız yazan),
 *                 uçlar `@KimlikGerekli` ve sahiplik sunucuda
 */
export const KIMLIK_YETERLI_EKRANLAR: ReadonlySet<string> = new Set([
  "bugun",
  "bildirimler",
  "yardim",
  "hesap",
  "kvkk",
  "canli-bilgilendirme",
  "notlarim",
]);

/**
 * Menüde alanı OLMAYAN ama var olan ekranlar: kendi girişi başka yerde.
 * Sürüm 9a'dan beri BOŞ — Bildirimlerim UNİKOÇ'taki gibi menüye girdi. Küme
 * duruyor: bir gün yalnız bağlantıdan açılan bir ekran gelirse yeri burası.
 */
export const ALANSIZ_EKRANLAR: ReadonlySet<string> = new Set<string>([]);

export interface GorunurAlan {
  anahtar: string;
  etiket: string;
  ikon: IkonAdi;
  grup?: string;
  bolum?: string;
  /** Bu kişiye görünen sekmeler (ekran anahtarları), sıralı. */
  sekmeler: string[];
  /** Alana tıklayınca açılan ekran: ilk görünen sekme, yoksa ilk görünen bağlamlı ekran. */
  giris: string;
  /** Alanın bütün ekranları (sekme + bağlamlı) — karşılama turu vurgusu için. */
  ekranlar: string[];
}

/**
 * Bu kişiye görünen alanlar.
 *
 * @param ekranGorunur bir ekran anahtarının menü izni bu kişide var mı
 * @param ekranEtiketi bir ekranın menüdeki adı
 *
 * TEK SEKMESİ GÖRÜNEN ALAN, SEKMENİN ADIYLA çiziliyor: tanımında birden çok
 * sekme olan "Deneme Sınavları" alanında yalnızca "Deneme tanımla" görünen bir
 * rolde menüde "Deneme Sınavları" yazması, içeri girince başka bir başlıkla
 * karşılaşmak olurdu.
 */
export function gorunurAlanlar(
  ekranGorunur: (ekran: string) => boolean,
  ekranEtiketi: (ekran: string) => string,
  alanlar: readonly AlanTanimi[] = ALANLAR,
): GorunurAlan[] {
  const sonuc: GorunurAlan[] = [];
  for (const alan of alanlar) {
    const sekmeler = alan.sekmeler.filter(ekranGorunur);
    const baglamli = (alan.baglamli ?? []).filter(ekranGorunur);
    const giris = sekmeler[0] ?? baglamli[0];
    if (giris === undefined) continue;
    /*
      Görünen TEK sekme alanın ANA ekranıysa (ilk sekme) girdinin UNİKOÇ adı kalıyor:
      yalnız denemeleri gören koçta "Deneme Sınavları" yazmalı, "Denemeler" değil.
    */
    const tekSekme =
      sekmeler.length === 1 && alan.sekmeler.length > 1 && sekmeler[0] !== alan.sekmeler[0];
    sonuc.push({
      anahtar: alan.anahtar,
      etiket: tekSekme && !alan.etiketiKoru ? ekranEtiketi(sekmeler[0]!) : alan.etiket,
      ikon: alan.ikon,
      ...(alan.grup !== undefined ? { grup: alan.grup } : {}),
      ...(alan.bolum !== undefined ? { bolum: alan.bolum } : {}),
      sekmeler,
      giris,
      ekranlar: [...alan.sekmeler, ...(alan.baglamli ?? [])],
    });
  }
  return sonuc;
}

/** Bir ekranın ait olduğu alanın anahtarı; alanı olmayan ekran (zilden açılan) için `null`. */
export function alanOf(ekran: string, alanlar: readonly AlanTanimi[] = ALANLAR): string | null {
  for (const alan of alanlar) {
    if (alan.sekmeler.includes(ekran) || (alan.baglamli ?? []).includes(ekran)) return alan.anahtar;
  }
  return null;
}
